/**
* DevExpress Dashboard (dimension-key.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { ModelSerializer } from '@devexpress/analytics-core/analytics-utils';
import * as ko from 'knockout';
import { DashboardFormatHelper } from '../../data/_format-helper';
import { localizer } from '../../data/_localizer';
import { SerializableModel } from '../serializable-model';
import { dimensionKeySerializationInfo } from './metadata/_color-scheme-entry';
export class DimensionKey extends SerializableModel {
    constructor(modelJson = {}, serializer = new ModelSerializer()) {
        super(modelJson, serializer, dimensionKeySerializationInfo);
        this.addDisposable(this.displayText = ko.pureComputed(() => {
            var displayText = null;
            if (!!this.value.value()) {
                if (this.value.type() === 'System.DateTime') {
                    var groupInterval = this.definition.dateTimeGroupInterval();
                    displayText = DashboardFormatHelper.format(new Date(this.value.value()), { dateType: 'short', format: groupInterval });
                }
                else {
                    displayText = this.value.value().toString();
                }
            }
            var predefinedDisplayText = localizer.getPredefinedString(displayText);
            if (predefinedDisplayText) {
                return predefinedDisplayText;
            }
            else {
                return displayText;
            }
        }));
    }
    getInfo() {
        return dimensionKeySerializationInfo;
    }
}
